import { useEffect } from "react";

const ABOUT_URL = "https://fde-staticwebsite-basebuddy-demo-global-01-ejeyawgsc0cderc0.z03.azurefd.net/";

export const About = () => {
    useEffect(() => {
        window.open(ABOUT_URL, "_blank", "noopener,noreferrer");
    }, []);

    return (
        <main style={{ padding: 50, maxWidth: 900, margin: "0 auto" }}>
            <p>
                Redirecting to the Base Buddy website...{" "}
                <a href={ABOUT_URL} target="_blank" rel="noopener noreferrer">
                    Click here if it doesn't open automatically.
                </a>
            </p>
        </main>
    );
};

export default About;
